/**
 * @generated SignedSource<<bd5c065033cf6a1a5a9509e7909059de>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RaffleStatus = "LOSER" | "ONGOING" | "WINNER" | "%future added value";
export type raffleIndexRafflesQuery$variables = {
  hubId: string;
  userId: string;
};
export type raffleIndexRafflesQuery$data = {
  readonly activeRaffles: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly status: RaffleStatus;
      readonly user: {
        readonly id: string;
      };
    }>;
  };
  readonly userRaffles: {
    readonly nodes: ReadonlyArray<{
      readonly hub: {
        readonly id: string;
      };
      readonly id: string;
      readonly status: RaffleStatus;
    }>;
  };
};
export type raffleIndexRafflesQuery = {
  response: raffleIndexRafflesQuery$data;
  variables: raffleIndexRafflesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "hubId",
  "variableName": "hubId"
},
v3 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000000
  }
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/)
],
v7 = [
  {
    "alias": "activeRaffles",
    "args": [
      {
        "fields": [
          (v2/*:: as any*/)
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      (v3/*:: as any*/)
    ],
    "concreteType": "RafflePage",
    "kind": "LinkedField",
    "name": "raffles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Raffle",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "userRaffles",
    "args": [
      {
        "fields": [
          (v2/*:: as any*/),
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      (v3/*:: as any*/)
    ],
    "concreteType": "RafflePage",
    "kind": "LinkedField",
    "name": "raffles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Raffle",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "raffleIndexRafflesQuery",
    "selections": (v7/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "raffleIndexRafflesQuery",
    "selections": (v7/*:: as any*/)
  },
  "params": {
    "cacheID": "f124c6a5112b0587fc42134692a46bc9",
    "id": null,
    "metadata": {},
    "name": "raffleIndexRafflesQuery",
    "operationKind": "query",
    "text": "query raffleIndexRafflesQuery(\n  $userId: UUID!\n  $hubId: UUID!\n) {\n  activeRaffles: raffles(filter: {hubId: $hubId}, pagination: {page: 0, pageSize: 1000000}) {\n    nodes {\n      id\n      status\n      user {\n        id\n      }\n    }\n  }\n  userRaffles: raffles(filter: {userId: $userId, hubId: $hubId}, pagination: {page: 0, pageSize: 1000000}) {\n    nodes {\n      id\n      status\n      hub {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "757333649a17fceeac8e603b9a137bbb";

export default node;
